<footer id="app-footer">
  <div class="d-flex justify-content-center pb-3">
    <dx-app-feedback appId="dx-portal" appName="DX Portal"></dx-app-feedback>
  </div>
  <hr class="hr-shadow mx-auto my-3" />
  <div class="pt-3 text-center">
    <div class="d-flex align-items-center justify-content-center">
      <a class="me-1 btn btn-sm btn-light text-muted" target="_blank"
        href="https://www.wrbcs.info/Policies/TermsOfUse.htm">Terms & Conditions</a>
      <a class="me-1 btn btn-sm btn-light text-muted" target="_blank"
        href="https://www.wrbcs.info/Policies/PrivacyPolicy.htm">Privacy Policy</a>
      <span class="mx-1 text-muted text-small">Copyright © {{ today | date: 'yyyy' }} W. R. Berkley, All Rights
        Reserved</span>
    </div>
    <div class="pt-3">
      <img [src]="authService.appConfig.brandLogo" />
    </div>
  </div>
</footer>
